module.exports = __webpack_public_path__ + "img/menu_mens_tenteki.aa68e28c.png";